import { QuoteProMergeDataset } from '../../datasets';
import { FakeAccountContactMergeData, FakeAccountMergeData, FakeCompanyMergeData, FakeEmployeeMergeData, FakeQuoteProMergeData, FakeQuoteProSiteMergeData } from '../data';


export class FakeQuoteProMergeDataset extends QuoteProMergeDataset {

    constructor(baseUrl: string = '') {
        super();

        this.quoteCompany = new FakeCompanyMergeData(baseUrl);
        this.quoteAccount = new FakeAccountMergeData();
        this.quoteContact = new FakeAccountContactMergeData();
        this.quoteOwner = new FakeEmployeeMergeData();
        this.quoteSite = new FakeQuoteProSiteMergeData();

        this.quote = new FakeQuoteProMergeData();


    }

}